import { render, staticRenderFns } from "./CustomerCampaignReceiptReward.vue?vue&type=template&id=55f56b0d"
import script from "./CustomerCampaignReceiptReward.vue?vue&type=script&lang=js"
export * from "./CustomerCampaignReceiptReward.vue?vue&type=script&lang=js"
import style0 from "./CustomerCampaignReceiptReward.vue?vue&type=style&index=0&id=55f56b0d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports